import "../../styles/AboutSerene.css";
import { motion } from "framer-motion";
import { useState } from "react";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";

import "yet-another-react-lightbox/plugins/counter.css";

// ----------------- GRID COVER IMAGES -----------------
import cover1 from "../../assets/serene-images/ConstructionImages/IMAGE_12-2.jpg";
import cover2 from "../../assets/serene-images/LiveImages/image13.jpeg";
import cover3 from "../../assets/images/serene-about-3.webp";
import cover4 from "../../assets/images/serene-about-4.webp";

// ----------------- IMAGE GALLERIES -----------------
import g1a from "../../assets/serene-images/ConstructionImages/IMAGE_4-3.jpg";
import g1b from "../../assets/serene-images/ConstructionImages/IMAGE_6-1.jpg";
import g1c from "../../assets/serene-images/ConstructionImages/IMAGE_6-1 (1).jpg";
import g1d from "../../assets/serene-images/ConstructionImages/IMAGE_8-2.jpg";
import g1e from "../../assets/serene-images/ConstructionImages/IMAGE_11.jpg";
import g1f from "../../assets/serene-images/ConstructionImages/IMAGE_12-2.jpg";
import g1g from "../../assets/serene-images/ConstructionImages/IMAGE_14-3.jpg";
import g1h from "../../assets/serene-images/ConstructionImages/IMAGE_17-1.jpg";
import g1i from "../../assets/serene-images/ConstructionImages/IMAGE_17-2.jpg";
import g1j from "../../assets/serene-images/ConstructionImages/IMAGE_23-1.jpg";


import VideoCover from "../../assets/palms-images/palms-construction.avif";
import januaryVideo from "../../assets/palms-images/palms-january.webm";

// ----------------- FEATURES DATA -----------------
const features = [
  {
    title: "Construction Progress",
    cover: cover1,
    type: "image",
    gallery: [g1a, g1b, g1c, g1d, g1e, g1f, g1g, g1h, g1i, g1j],
  },
  // {
  //   title: "Live Images",
  //   cover: cover2,
  //   type: "image",
  //   gallery: [g2a, g2b, g2c, g2d, g2e, g2f, g2g, g2h, g2i, g2j, g2k, g2l],
  // },
  {
    title: "Video Gallery",
    cover: VideoCover,
    type: "video",
    gallery: [
      // Add your video slides here, for example:
      { type: "video", src: januaryVideo, title: "JANUARY CONSTRUCTION" }
    ],
  },
  // {
  //   title: "Club House",
  //   cover: cover4,
  //   type: "image",
  //   gallery: [g4a, g4b, g4c],
  // },
];

// ----------------- ANIMATIONS -----------------
const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.25, delayChildren: 0.2 } },
};

const card3D = {
  hidden: { opacity: 0, y: 60, rotateY: 12, scale: 0.96 },
  show: {
    opacity: 1,
    y: 0,
    rotateY: 0,
    scale: 1,
    transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] },
  },
};

const fadeUp = {
  hidden: { opacity: 0, y: 45, filter: "blur(10px)" },
  show: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: { duration: 0.9, ease: "easeOut" },
  },
};

const wordContainer = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.15,
    },
  },
};

const wordVariant = {
  hidden: { y: 35, opacity: 0, filter: "blur(6px)" },
  show: {
    y: 0,
    opacity: 1,
    filter: "blur(0px)",
    transition: { duration: 0.8, ease: "easeOut" },
  },
};

const line1 = "Construction Progress".split(" ");
const line2 = "".split(" ");

// ================= COMPONENT =================
export default function ConstructionProgressSerene() {
  const [open, setOpen] = useState(false);
  const [slides, setSlides] = useState([]);
  const [index, setIndex] = useState(0);

  // ---------- OPEN GALLERY ----------
  const openGallery = (item) => {
    if (!item.gallery?.length) return;

    if (item.type === "image") {
      setSlides(item.gallery.map((img) => ({ type: "image", src: img })));
    } else {
      setSlides(item.gallery); // custom video slides
    }
    setIndex(0);
    setOpen(true);
  };

  // ---------- CUSTOM SLIDE RENDERER (FOR VIDEO) ----------
  const renderSlide = ({ slide, offset }) => {
    if (slide.type === "video") {
      const shouldLoadVideo = offset === undefined || offset === 0;

      return (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px 16px 16px",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "12px",
            }}
          >
            {slide.title ? (
              <div
                style={{
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: 600,
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                }}
              >
                {slide.title}
              </div>
            ) : null}
            <video
              src={shouldLoadVideo ? slide.src : undefined}
              preload="none"
              controls
              controlsList="nodownload noplaybackrate"
              disablePictureInPicture
              disableRemotePlayback
              style={{
                width: "100%",
                flex: 1,
                minHeight: 0,
                objectFit: "contain",
              }}
            />
          </div>
        </div>
      );
    }
    return null; // images handled automatically
  };

  return (
    <motion.section
      className="about-serene py-5"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.3 }}
      variants={container}
    >
      <div className="container py-3">

        <div className="row mb-5">
          <div className="col-lg-5 d-flex align-items-center justify-content-center">
            <div className="mp-text-block">

              <motion.p className="about-text text-black" variants={fadeUp}>
                Development at Palms is progressing steadily with high-quality standards and timely execution, ensuring a well-built and dependable living environment.
              </motion.p>


            </div>
          </div>


          <div className="col-lg-7 d-flex align-items-center justify-content-end mt-4 mt-lg-0">
            <motion.h1
              className="sage-title display-4"
              variants={wordContainer}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0.6 }}
            >
              {line1.map((word, i) => (
                <motion.span
                  key={`line1-${i}`}
                  variants={wordVariant}
                  style={{ display: "inline-block", marginRight: "0.35em" }}
                >
                  {word}
                </motion.span>
              ))}
              <br />
              {line2.map((word, i) => (
                <motion.span
                  key={`line2-${i}`}
                  variants={wordVariant}
                  style={{ display: "inline-block", marginRight: "0.35em" }}
                >
                  {word}
                </motion.span>
              ))}
            </motion.h1>
          </div>
        </div>

        {/* ================= GRID ================= */}
        <motion.div className="row g-4" variants={container}>
          {features.map((item, i) => (
            <motion.div
              className="col-md-6 col-lg-6"
              key={i}
              variants={card3D}
              whileHover={{ scale: 1.03 }}
            >
              <div className="feature-card" onClick={() => openGallery(item)}>
                <img
                  src={item.cover}
                  alt={item.title}
                  className="img-fluid rounded-2 feature-img"
                />
                <p className="feature-title mt-3">{item.title}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>

      </div>

      {/* ================= POPUP ================= */}
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={slides}
        index={index}

        /* Plugins */
        plugins={[Zoom, Counter, Fullscreen]}

        /* Image display */
        imageFit="contain"

        /* Zoom behavior */
        zoom={{
          maxZoomPixelRatio: 4,     // how much user can zoom
          zoomInMultiplier: 1.5,    // zoom speed
          doubleTapDelay: 300,
          doubleClickDelay: 300,
        }}

        /* Track slide change */
        on={{ view: ({ index }) => setIndex(index) }}

        /* Custom renderer (for videos) */
        render={{ slide: renderSlide }}

        /* Counter position */
        counter={{
          container: {
            style: {
              top: "16px",
              left: "16px",
              right: "auto",
              bottom: "auto",
              fontSize: "14px",
            },
          },
        }}

        /* Background */
        styles={{
          container: { backgroundColor: "rgba(0,0,0,0.96)" },
        }}
      />


    </motion.section>
  );
}
